import template from './template.html'

export default {
  bindings: {
    accessoryDetails: '<',
    accessory: '<'
  },
  template
}
